import { createApiCall } from 'lib/base';
import { generateEndpoint } from 'utils/urlHelpers';

const FETCH_HOME_WIDGET_BANNERS_API_ID = 'DASHBOARD/FETCH_HOME_WIDGET_BANNERS_API_ID';

const apiCall = createApiCall(
  FETCH_HOME_WIDGET_BANNERS_API_ID,
  (params: { home_widget_id: string }) => ({
    endpoint: generateEndpoint({
      host: `/api/admin/home-widget-banners`,
      params,
    }),
    method: 'GET',
  })
);

export default apiCall;
